import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { safeReturnUrl } from '../utils/return-url';

/** Keeps signed-in users off /login and /signup, sending them to their
 * account area instead (or a safe returnUrl if one was supplied). */
export const guestGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.bootstrap().pipe(
    take(1),
    map(() => {
      if (!authService.isAuthenticated()) return true;
      const returnUrl = safeReturnUrl(route.queryParamMap.get('returnUrl'));
      return returnUrl ? router.parseUrl(returnUrl) : router.createUrlTree(['/account']);
    }),
  );
};
